const DOCUMENT_LINK_RE = /(^|\s)(#.*)\[(\d*)\](\s|$)/gm

export const appendDocumentLinks = (text: string, business_id: string): string => {
  return text.replace(DOCUMENT_LINK_RE, `$1<a href="/${business_id}/documents?id=$3">$2</a>$4`)
}
